import { render, staticRenderFns } from "./ShipmentDetailShipping.vue?vue&type=template&id=dfe49c5c&scoped=true&"
import script from "./ShipmentDetailShipping.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetailShipping.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDetailShipping.vue?vue&type=style&index=0&id=dfe49c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe49c5c",
  null
  
)

export default component.exports